import React from 'react';

const contact = () => {
        return (
            <div className="box1">
                    <h2>Get in Touch</h2>
                        <div className="icon">
                            <i class="fa-solid fa-location-dot"></i>
                            <label htmlFor=' '>Current Location: UPM, Selango, Malaysia</label>
                        </div>
            </div>
        );
    }

export default contact;